import React, { type FC } from 'react'

import {
  Grid,
  GridCell,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
} from 'mailup-web-components'

interface ResultItemSkelProps {
  cols: number
  spans: number[]
}

const ResultItemSkel: FC<ResultItemSkelProps> = ({ cols, spans }) => {
  return (
    <Grid cols={cols}>
      {spans.map((c, index) => (
        <React.Fragment key={index}>
          <GridCell span={c}>
            <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
          </GridCell>
        </React.Fragment>
      ))}
    </Grid>
  )
}

export default ResultItemSkel
